<template>
  <div class="sub-menu-preorder sub-menu-details sub-menu">
    <p
      class="
        text-desktop-small-desktop
        text-mobile-small-mobile
        sub-menu-preorder__text
      "
      v-text="content?.preorder?.text"
    />

    <!-- Upper bullet list -->
    <div
      v-if="content?.preorder?.bullets?.length"
      class="sub-menu-details__bullets rte"
    >
      <ul class="sub-menu-details__bullets-list">
        <li
          v-for="(bullet, index) of content.preorder.bullets"
          :key="`sub-menu-details-bullet-${index}`"
          class="
            text-desktop-small-desktop
            text-mobile-small-mobile
            sub-menu-details__bullets-item
          "
          v-text="bullet"
        />
      </ul>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Sub menu preorder
 * -----------------------------------------------------------------------------
 * Preorder sub menu component.
 *
 * @param {Object} content - Content to be displayed.
 */
export default {
  name: 'SubMenuPreorder',

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
